import { render, staticRenderFns } from "./FooterHomePage.vue?vue&type=template&id=2ff9aba6&scoped=true&"
import script from "./FooterHomePage.vue?vue&type=script&lang=js&"
export * from "./FooterHomePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff9aba6",
  null
  
)

export default component.exports